// @ts-check
import { StyledHeader } from './Header.style.js';
import { pluralize } from 'common/utils/utils';
import { flattenTree } from 'components/base/MultiLevelDropdown/MultiLevelDropdown.utils';
import { Tooltip } from '@material-ui/core';
import Text from 'components/base/Text';
import useAccountType from 'views/root/views/home/hooks/useAccountType.js';
import { StyledWidgetHeader } from 'components/base/common-styles.js';
import { LBButton, LBEditIcon } from '@linearb/buzz';

const Header = ({ teams, isCustomizeMetrics, onClick }) => {
  const { isUserViewer } = useAccountType();
  const flatTree = flattenTree(teams, 'children');
  const numOfGroups = flatTree.filter(({ isParent }) => isParent).length;
  const numOfTeams = flatTree.length - numOfGroups;

  return (
    <StyledHeader>
      <StyledWidgetHeader
        data-cy='group-teams-table-title'
        style={{ paddingBottom: '2rem' }}
      >
        {numOfGroups > 0 && `${pluralize(numOfGroups, 'Group')}, `}
        {`${pluralize(numOfTeams, 'Team')}`}
      </StyledWidgetHeader>
      {isCustomizeMetrics && !isUserViewer && (
        <Tooltip
          data-testid='edit-columns-btn'
          title={
            <Text color='shark' data-testid='customize-tooltip'>
              Switch metrics
            </Text>
          }
        >
          <div className='mb-4'>
            <LBButton onClick={onClick}>
              <LBEditIcon /> Edit Columns
            </LBButton>
          </div>
        </Tooltip>
      )}
    </StyledHeader>
  );
};

export default Header;
